import axios from '@axios'
import axiosDefaultConfig from '@core/app-config/axiosDefaultConfig'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProfile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${axiosDefaultConfig.backendEndPoint}profile`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    patchPaymentPreferences(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`${axiosDefaultConfig.backendEndPoint}profile/paymentpreferences`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
